import React from 'react'
import useSound from 'use-sound';
import boopSfx from '../assets/audios/boop.mp3';
import plungerSfx from '../assets/audios/plunger.mp3';
import biteSfx from '../assets/audios/bite.mp3';

import miniblue from '../assets/images/mineblue-Box.svg';
import bomb from '../assets/images/box-boom.svg';
import diamond from '../assets/images/diamond.svg';


import { useCustomizeContext } from '../context';



export default function Cell({ details, updateFlag, revealcell, autoIsStop, isBet, setIsBet }) {
  // Adding three sounds
  const [playOne] = useSound(plungerSfx, { volume: 5.6 });
  const [playTwo] = useSound(boopSfx, { volume: 10.5 });
  const [playThree] = useSound(biteSfx, { volume: 10.5 });
  const style = {
    cellStyle: {
      width: 40,
      height: 40,
      backgroundColor: details.revealed && details.value !== 0 ? details.value === 'X' ? 'red' : ' #00226d' : details.revealed && details.value === 0 ? '#00226f' : '#000',
      opacity: '0.8',
      border: '3px solid white',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: '20px',
      cursor: 'pointer',
      color: 'cyan',
      fontWeight: '1000'
    },
  }

  const {
    mineGameMode: {
      mineMode,
    },
    hitLength: {
      hitCount, setHitCount,
    },
  } = useCustomizeContext();

  // Playing Sound on differents Clicks

  const click = () => {

    if (details.value === 'X') {
      playTwo();
    } else {
      playOne();
    }
    // calling revealcell for specific cell x and y
    revealcell(details.x, details.y);
  }

  // Right Click Function

  const rightclick = (e) => {
    updateFlag(e, details?.x, details?.y)
    playThree();
  }
  // rendering the cell component and showing the different values on right and left clicks  onContextMenu={rightclick} 

  return (
    <>
      <div style={{ cursor: "pointer" }} class="mine-box" onClick={isBet && mineMode === "manual" ? click : mineMode === "auto" ? rightclick : ""}>
        {!details?.revealed && details?.flagged ? (
          <img src={miniblue} alt="" class="img-fluid  imgAuto" />
        ) : details?.revealed && details?.value !== 0 ? (
          details?.value === "X" ? (
            <img src={bomb} alt="" class="img-fluid" />
          ) : (
            <img src={diamond} alt="" class="img-fluid" />
          )
        ) : (
          <img src={miniblue} alt="" class="img-fluid" />
        )}
      </div>
    </>
  )
}


